import { Box } from '@mui/material'
import React, { useState } from 'react'
import BatchReleaseCertificate from '../../../../Manufacturer/print/BatchReleaseCertificate';
import { LoadingButton } from '@mui/lab';
import NoDataCard from '../../../../../../components/no-data-card';
import {  selectFollowCycle } from '../../../../../slices/common';
import {  useSelector } from 'react-redux';

const DownloadBatchReleaseCertificate = () => {
  const [publishModal, setPublishModal] = useState(false)
     const currentCycle = useSelector(selectFollowCycle);
  
  return (
  currentCycle?.coa_forms_id ? ( 
    <Box>
      
         <Box
  sx={{
    display: 'flex',
    justifyContent: 'flex-end',
  }}
>

            <LoadingButton
              type="button"
              size="small"
              onClick={()=>setPublishModal(true)}
              className="!w-[100px] "
              >
              Print
            </LoadingButton>
              </Box>
      <BatchReleaseCertificate
        open={publishModal}
        onClose={() => {
          setPublishModal(false);
        }}
        isVisible={true}
      />
       
    </Box>
    ) : (
                    <div >
                        <NoDataCard heading="No Data to Display" />
                    </div>
                )
  )
}

export default DownloadBatchReleaseCertificate